import { render, staticRenderFns } from "./jobsList.vue?vue&type=template&id=d6040a3c&scoped=true"
import script from "./jobsList.vue?vue&type=script&lang=js"
export * from "./jobsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6040a3c",
  null
  
)

export default component.exports